"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInsightInteractionsScreen = exports.InsightInteractions = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var constants_1 = require("../../../constants");
var InsightDrillConfigPanel_1 = require("./InsightDrillConfigPanel/InsightDrillConfigPanel");
var overlayController = sdk_ui_kit_1.OverlayController.getInstance(constants_1.DASHBOARD_HEADER_OVERLAYS_Z_INDEX);
exports.InsightInteractions = function (_a) {
    var widget = _a.widget;
    var widgetRefSuffix = sdk_model_1.isInsightWidget(widget)
        ? util_1.stringUtils.simplifyText(sdk_model_1.objRefToString(widget.ref))
        : "";
    var classes = classnames_1.default("configuration-scrollable-panel", "s-configuration-scrollable-panel", "s-visualization-" + widgetRefSuffix);
    return (react_1.default.createElement(sdk_ui_kit_1.ScrollablePanel, { className: classes },
        react_1.default.createElement(sdk_ui_kit_1.OverlayControllerProvider, { overlayController: overlayController },
            react_1.default.createElement(InsightDrillConfigPanel_1.InsightDrillConfigPanel, { widgetRef: widget.ref }))));
};
function createInsightInteractionsScreen(widget) {
    return react_1.default.createElement(exports.InsightInteractions, { widget: widget });
}
exports.createInsightInteractionsScreen = createInsightInteractionsScreen;
//# sourceMappingURL=InsightInteractions.js.map